import { Autocomplete } from 'src/components/Autocomplete';
import { Chip } from 'src/components/Chip';
import { TextField } from 'src/components/TextField';

interface PackagePaymentTypesFilterProps {
  label: string;
  value: string[] | undefined;
  setValue: (newVal: string[]) => void;
  valueOnly?: boolean;
}

const packagePaymentTypes = [
  { id: null, name: 'All Packages' },
  { id: 'single_purchase', name: 'One Time Purchases' },
  { id: 'subscription', name: 'Subscriptions' },
  { id: 'free', name: 'Assigned Free' },
];

export const PackagePaymentTypesFilter: React.FC<
  PackagePaymentTypesFilterProps
> = ({ label, value, setValue, valueOnly }) => {
  const selectedValues = value ? String(value).split(',') : [];

  if (valueOnly) {
    return selectedValues.length > 0 ? (
      <>
        {selectedValues
          .map(
            (v) =>
              packagePaymentTypes.find((option) => option.id === v)?.name || ''
          )
          .join(', ')}
      </>
    ) : null;
  }

  const selectedOptions = selectedValues.map(
    (v) =>
      packagePaymentTypes.find((option) => option.id === v) || {
        id: v,
        name: v,
      }
  );

  return (
    <Autocomplete
      multiple
      options={packagePaymentTypes}
      getOptionLabel={(option) =>
        typeof option === 'string'
          ? packagePaymentTypes.find((o) => o.id === option)?.name || option
          : option.name
      }
      value={selectedOptions}
      onChange={(_, newValue) => {
        setValue(
          newValue.map((v) => (typeof v === 'string' ? v : v.id)).join(',')
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Select Package Payment Types"
        />
      )}
      renderTags={(value: readonly any[], getTagProps) =>
        value.map((option: any, index: number) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              label={typeof option === 'string' ? option : option.name}
              key={key}
              {...tagProps}
            />
          );
        })
      }
    />
  );
};
